import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useFormikWithoutDirtyForm } from "../../../../../../../../../forms/useFormikWithDirtyForm";
import { OwnClaimFormValue } from "../../../../../OwnClaimsView.types";
import { createOwnClaimSchema } from "../../../../../OwnClaimsView.validation";

export function useOwnClaimDialog(
  claim: OwnClaimFormValue,
  onSave: (claim: OwnClaimFormValue) => void,
  onClose: () => void
) {
  const { t } = useTranslation();

  const validationSchema = useMemo(() => createOwnClaimSchema(t), [t]);

  const formik = useFormikWithoutDirtyForm<OwnClaimFormValue>({
    initialValues: claim,
    validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    onSubmit: (values) => {
      onSave(values);
      onClose();
    },
  });

  return { formik };
}
